import { render, staticRenderFns } from "./NYTConnections.vue?vue&type=template&id=7b8d0d19&scoped=true&"
import script from "./NYTConnections.js?vue&type=script&lang=js&"
export * from "./NYTConnections.js?vue&type=script&lang=js&"
import style0 from "./NYTConnections.scss?vue&type=style&index=0&id=7b8d0d19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d0d19",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NYTCard: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTCard/NYTCard.vue').default,NYTLatest: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTLatest/NYTLatest.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
